var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.$t('providersDealsSection.title'))}}),_vm._v(" "),_c('div',{class:_vm.$style.providers},_vm._l((_vm.partners),function(partner){return _c('ProviderCard',{key:partner.slug,attrs:{"title":partner.name,"link":_vm.localePath({
        name: 'provider-slug',
        params: {
          slug: partner.slug,
        },
      }),"logo":partner.logo}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }